import { render, staticRenderFns } from "./shijiEmailLogin.vue?vue&type=template&id=03d12b87&scoped=true"
import script from "./shijiEmailLogin.vue?vue&type=script&lang=js"
export * from "./shijiEmailLogin.vue?vue&type=script&lang=js"
import style0 from "./shijiEmailLogin.vue?vue&type=style&index=0&id=03d12b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d12b87",
  null
  
)

export default component.exports